{
  "app": {
    "update": {
      "message": "Update is available",
      "confirm": "Install"
    },
    "offlineWarning": {
      "message": "Internet connection lost",
      "description": "You will be switched to <strong>offline</strong> mode. You'll still be able to access your <strong>downloaded</strong> work orders."
    },
    "offlineToolbar": {
      "info": "Offline mode",
      "connected": "Internet connected",
      "disconnected": "No connection to the internet",
      "switchToOnline": "Switch to online",
      "offlineChanges": "Offline changes"
    },
    "storageWarning": {
      "message": "You are running out of storage<br />To be able to download new work orders - remove old or unused ones."
    }
  },
  "disclaimers": {
    "updateDownloaded": "Some of your downloaded work orders need to be updated"
  },
  "components": {
    "searchBar": {
      "ok": "Ok",
      "cancel": "Cancel"
    },
    "emptyList": {
      "title": "This list is empty",
      "info": "No items found"
    },
    "confirm": {
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "cableDialog": {
      "article": "Article",
      "articleMissing": "Article is not set on the work-line and the cable pulling dialog could not be used.",
      "company": "Company",
      "notSelected": "Not selected",
      "editCompany": "Edit company",
      "loadingLocations": "Loading locations…",
      "location": "Location",
      "quantity": "(QTY: {{quantity}})",
      "locationRequired": "Location is required",
      "plannedLength": "Planned Length",
      "pulledFromDrum": "Pulled from drum",
      "wholeNegative": "The value cannot be negative",
      "wholeNotNumber": "The whole value accepts only numbers",
      "wholeRequired": "Field cannot be empty",
      "decimalNegative": "The decimal value cannot be negative",
      "decimalMax": "The decimal value cannot exceed 99",
      "decimalNotNumber": "The decimal value accepts only numbers",
      "asPlanned": "As planned",
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "quantityDialog": {
      "allDone": "All Done",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "done": "Done",
      "total": "Total"
    },
    "putOnHoldInfoDialog": {
      "title": "Work order put on hold",
      "description": "Put on hold by ",
      "close": "Close"
    },
    "documentStatusDialog": {
      "title": "Set document status",
      "cancel": "Cancel",
      "confirm": "Confirm"
    }
  },
  "header": {
    "workCenter": "Work center",
    "project": "Project"
  },
  "profile": {
    "filterWorkCenters": "Find work center...",
    "filterProjects": "Find project...",
    "selectCompanyStepTitle": "Select company per project",
    "selectCompanyStepDescription": "Company is required for using the warehouse location used by Cable Pulling. You might skip this if you don't use this feature.",
    "loadingCompanies": "Loading companies...",
    "company": "Company",
    "noCompaniesForProject": "No companies available for this project.",
    "roles": {
      "FOREMAN": "Foreman",
      "OPERATOR": "Operator"
    },
    "continue": "Continue",
    "done": "Done",
    "back": "Back",
    "removeFromSelection": "Remove from selection: ",
    "removeSiteConfirm": "Remove this site from your selection?",
    "removeWorkCenterConfirm": "Remove this work center from your selection?",
    "removeProjectConfirm": "Remove this project from your selection?",
    "workOrderDateInfo": "Only work orders scheduled to start within the next 180 days will be displayed.",
    "workCenterReplacementInfo": "EPUE-codes will be replaced with new discipline codes (Q%). Please note that your project might still use EPUE until replacement is complete."
  },
  "workOrderComments": {
    "title": "Notes",
    "add": {
      "confirm": "Add",
      "cancel": "Cancel"
    },
    "edit": {
      "editNote": "Edit note",
      "deleteNote": "Delete note",
      "saveNote": "Save",
      "changePhoto": "Change photo",
      "changeVideo": "Change video"
    },
    "delete": {
      "deleteNoteBy": "Delete note by"
    },
    "replies": {
      "replyAction": "Reply",
      "reply": "reply",
      "replies": "replies",
      "show": "· Show",
      "hide": "· Hide",
      "placeholder": "Write a reply… (Enter to send, Shift+Enter for new line)",
      "send": "Send",
      "cancel": "Cancel"
    },
    "referenceType": {
      "WORK_ORDER": "Work Order",
      "WORK_LINE": "Work Line",
      "MATERIAL": "Material",
      "EQUIPMENT": "Equipment",
      "OBJECT": "Object",
      "DOCUMENT": "Document",
      "MIPS_CONSTRUCTION": "MIPS Construction",
      "MIPS_ENGINEERING": "MIPS Engineering",
      "MIPS_MATERIAL": "MIPS Material"
    },
    "list": {
      "addNote": "Add note",
      "workOrderNote": "(Work order note)"
    },
    "empty": {
      "title": "No current content",
      "info": "Start creating notes by using the “add note” button."
    }
  },
  "workOrderFeedback": {
    "title": "Job feedback",
    "summary": {
      "workOrder": "Work order",
      "title": "Title",
      "platform": "Site",
      "taskNo": "Task No",
      "date": "Date"
    },
    "prompt": {
      "title": "How did the job go?",
      "info": "Select a status. For negative or neutral feedback, include a short comment so the job card can be improved."
    },
    "sentiment": {
      "NOT_GOOD": "Not good",
      "NEUTRAL": "OK, but needs improvement",
      "GOOD": "Good"
    },
    "topicsTitle": "What is the feedback about?",
    "commentLabel": "Comment",
    "commentPlaceholder": "Briefly describe what worked / did not work.",
    "impactLabel": "Potential impact",
    "impact": {
      "NONE": "None",
      "SCHEDULE_PROGRESS": "Schedule / progress",
      "COST": "Cost",
      "HMS": "HMS",
      "QUALITY": "Quality",
      "UNSURE": "Unsure"
    },
    "performedByLabel": "Performed by",
    "improvementLabel": "Suggested improvement",
    "improvementPlaceholder": "What should be changed before the next execution?",
    "submit": "Submit feedback",
    "submitting": "Submitting...",
    "submitSuccess": "Feedback submitted.",
    "submitQueuedOffline": "Feedback saved offline and will sync when connection is restored.",
    "submitError": "Unable to submit feedback. Please try again.",
    "recipientWarning": "No feedback recipient email is configured for this project.",
    "noRecipientConfirm": {
      "title": "No recipient email configured",
      "description": "This project has no feedback recipient email. The feedback can be saved, but no email will be sent.",
      "saveAnyway": "Save anyway"
    },
    "resend": "Resend",
    "resending": "Resending...",
    "resendSuccess": "Feedback resent.",
    "resendError": "Unable to resend feedback. Please try again.",
    "previousTitle": "Your previous feedback",
    "empty": {
      "title": "No feedback yet",
      "info": "Your submitted feedback entries will appear here."
    },
    "validation": {
      "sentimentRequired": "Please select a status.",
      "commentRequired": "Comment is required for this status.",
      "potentialImpactRequired": "Please select at least one potential impact."
    }
  },
  "workOrderDetails": {
    "assignTo": "Assign to",
    "claim": "Claim work order",
    "description": "Description",
    "equipment": {
      "customerId": "Customer ID",
      "description": "Description",
      "equipment": "Equipment",
      "functionalLocation": "Func.Loc.",
      "materialNo": "Material no.",
      "serialNo": "Serial no.",
      "storageLocation": "Stor.Loc."
    },
    "hoursTable": {
      "header": {
        "description": "Description",
        "hours": "Hours"
      },
      "row": {
        "estimate_hours": "Estimated hours",
        "hours_remaining": "Hours remaining",
        "hours_earned_this_week": "Hours earned this week"
      }
    },
    "estimatedHours": "Est. hrs.",
    "finish": "Finish",
    "madeBy": "Made by",
    "releaseToAll": "Release to all",
    "remainingHours": "Hrs. left",
    "start": "Start",
    "usedHours": "Hrs. used",
    "wbs": "WBS",
    "statusName": "Status",
    "precedingWorkOrder": "Preceding Work Order",
    "succeedingWorkOrder": "Succeeding Work Order",
    "relatedWorkOrders": "Related Workorders",
    "putOnHold": "Put work order on hold",
    "releaseWorkOrder": "Release work order",
    "confirmPutOnHoldTitle": "Put Work Order:",
    "confirmPutOnHoldDescription": "{{ workOrderNumber }} on hold?",
    "confirmReleaseOnHoldDescription": "{{ workOrderNumber }}?",
    "operators": {
      "empty": {
        "info": "No operators found"
      }
    }
  },
  "workOrderDocuments": {
    "jobPackage": "Job",
    "attachment": "Att",
    "video": "Video",
    "timeDrawing": "Doc",
    "timeDrawings": "Time Drawings",
    "revision": "Revision",
    "unauthorized": "You are not authorized to access this document",
    "loadFailed": "This document could not be loaded",
    "notAvailableOffline": "This document has not been downloaded for offline use",
    "empty": {
      "title": "No current content",
      "info": "No documents have been assigned to this Work Order yet."
    },
    "notSupported": "If your browser cannot embed this document, click to download file.",
    "status": {
      "redlineMarkup": "Redline Markup",
      "forInfo": "For Info",
      "noChange": "No Change",
      "label": "Status: {{id}} ({{name}})",
      "notSetLabel": "Status: not set"
    }
  },
  "offlineDownload": {
    "title": "Download for offline use",
    "options": {
      "files": "Files:",
      "allFiles": "All files",
      "jobPackage": "Job package",
      "attachments": "Attachments",
      "docs": "Documents",
      "model3d": "3D files",
      "videos": "Videos"
    },
    "badges": {
      "model3d": "3D",
      "video": "Video"
    },
    "metadata": "Metadata",
    "total": "Selected: {{count}} documents, {{size}}",
    "unknownSize": "(+ {{count}} of unknown size)",
    "progress": {
      "running": "{{done}}/{{total}} downloaded. The download will continue in the background if you close the dialog.",
      "done": "Download complete, you can close the dialog.",
      "doneWithFailures": "Download complete, but {{failed}} of {{total}} documents failed. You can close the dialog.",
      "failed": "The download failed. Check the connection and try again."
    },
    "noDocuments": "This work order has no documents.",
    "loadFailed": "The document list could not be loaded.",
    "offline": "You are offline. Connect to the network to download.",
    "status": {
      "queued": "Waiting",
      "downloading": "Downloading",
      "done": "Downloaded",
      "failed": "Failed"
    },
    "close": "Close",
    "download": "Download"
  },
  "workOrderLines": {
    "backTo": null,
    "confirmWarning": "This scope only has {{quantity}} of {{plannedQuantity}} registered",
    "confirmComplete": "Are you sure that you want to mark the work line as done?",
    "continueTo": null,
    "confirmReOpenWarning": "Are you sure you want to uncheck the scope:",
    "cableCompanyIdMissing": "Company ID is not set for this project. Please set the company ID in settings to load warehouse locations.",
    "cableArticleMissing": "Article is missing for this scope. Reporting should be done in MIPS.",
    "cableNoLocationsFound": "No locations found for the selected company. Verify that you have selected the correct company, or contact your supervisor if you suspect the warehouse locations in MIPS are not up to date.",
    "cablePulledLengthExceedsAvailable": "Pulled length is longer than available on selected location/drum, please select another location/drum.",
    "end": null,
    "installedQuantity": "Installed Qty.",
    "lineComplete": "Done",
    "lineDescription": "Scope",
    "lineId": "ID",
    "lineNo": "Line #",
    "plannedQuantity": "Planned Qty.",
    "start": null,
    "work": null
  },
  "workOrderList": {
    "filters": {
      "open": "All",
      "closed": "Archived",
      "released": "Released",
      "unreleased": "Unreleased",
      "assigned": "Mine",
      "downloaded": "Downloaded",
      "dueThisWeek": "Due this week",
      "overDue": "Overdue"
    },
    "estimatedHours": "Est. hrs.",
    "finish": "Finish",
    "searchLabel": "Search",
    "show": "Show",
    "sortActHoursAsc": "Actual hours (low to high)",
    "sortActHoursDesc": "Actual hours (high to low)",
    "sortEstFinishDateAsc": "Finish date (first to last)",
    "sortEstFinishDateDesc": "Finish date (last to first)",
    "sortEstHoursAsc": "Estimated hours (low to high)",
    "sortEstHoursDesc": "Estimated hours (high to low)",
    "sortEstStartDateAsc": "Start date (first to last) ",
    "sortEstStartDateDesc": "Start date (last to first)",
    "sortWorkOrderNumberAsc": "Alphabetically(A to Z)",
    "sortWorkOrderNumberDesc": "Alphabetically(Z to A)",
    "sortLabel": "Sort",
    "start": "Start",
    "empty": {
      "info": "No work orders found"
    }
  },
  "workOrderMaterials": {
    "material": "Material",
    "articleNumber": "Article no.",
    "available": "Yes",
    "description": "Description",
    "quantity": "Quantity",
    "status": "Available",
    "materialStatus": "Material Status",
    "unavailable": "No",
    "empty": {
      "title": "This list is empty",
      "info": "No materials have been added to this Work Order yet."
    },
    "location": "Location"
  },
  "weightReport": {
    "title": "Weight Change / Additional Work",
    "sending": "Sending…",
    "cancel": "Cancel",
    "duplicate": "Duplicate",
    "sendSuccess": "Weight schema sent",
    "sendError": "Could not send the weight schema. Please try again.",
    "lineSaveError": "Could not save the line. Please try again.",
    "lineDeleteError": "Could not delete the line. Please try again.",
    "send": {
      "action": "Send {{count}} line(s)",
      "offlineHint": "You have to be online to send the schema.",
      "pendingHint": "Waiting for offline changes to sync before the schema can be sent."
    },
    "status": {
      "draft": "Not sent",
      "sent": "Sent"
    },
    "currentSchema": {
      "title": "Current schema",
      "empty": "No lines added yet"
    },
    "line": {
      "add": "Add line",
      "addTitle": "New line",
      "editTitle": "Edit line",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save line",
      "saving": "Saving…",
      "tag": "Tag / description",
      "quantity": "Qty / metres",
      "descriptionColumn": "Material / work activity",
      "status": "Status"
    },
    "jobCard": {
      "title": "Job card information",
      "workOrderNumber": "Work order number",
      "jobTitle": "Title",
      "platform": "Platform",
      "performedBy": "Performed by / name"
    },
    "registration": {
      "mainCategory": "Main category",
      "hours": "Hours spent",
      "predefinedOptions": "Predefined options – select all that apply"
    },
    "category": {
      "ADDITIONAL_WORK": "Additional work",
      "WEIGHT_CHANGE": "Weight change",
      "OTHER": "Other"
    },
    "weight": {
      "installed": "Mounted weight",
      "removed": "Dismounted weight",
      "total": "Total weight",
      "followUp": "Change follow-up required?",
      "followUpYes": "Yes",
      "followUpNo": "No",
      "description": "Description of material / work activity",
      "descriptionPlaceholder": "Briefly describe what was done, why it was additional work, and any impact on hours, weight or schedule/progress."
    },
    "documentation": {
      "recipient": "Shared mailbox / recipient",
      "recipientHint": "Configured per project",
      "comment": "Comment to Supervisor / Integration Manager",
      "commentPlaceholder": "Any additional comment or need for clarification.",
      "attachments": "Attachments",
      "downloadAttachment": "Download",
      "attachmentsLoading": "Loading attachments...",
      "attachmentsPendingHint": "These files will be uploaded when the line is saved.",
      "attachmentsOfflineHint": "Attachments require an internet connection.",
      "noAttachments": "No attachments",
      "attachmentLoadError": "Could not load attachments.",
      "attachmentUploadError": "Could not upload one or more attachments.",
      "attachmentDownloadError": "Could not download the attachment."
    },
    "details": {
      "sentAt": "Email sent",
      "notSent": "Not sent"
    },
    "history": {
      "title": "Sent schemas for this work order",
      "empty": "No schemas sent yet",
      "lineCount": "{{count}} line(s)"
    }
  },
  "workOrderObjectHierarchy": {
    "workLines": "Work Lines",
    "empty": {
      "info": "No Work Lines have been added to this Work Order yet."
    },
    "selectStatus": "Status"
  },
  "workOrderOperations": {
    "backTo": "Back to",
    "continueTo": "Continue to",
    "end": "End",
    "installedQuantity": "Done",
    "lineComplete": "Done",
    "lineDescription": "Description",
    "lineId": "ID",
    "lineNo": "Line #",
    "plannedQuantity": "Total",
    "start": "Start",
    "workCenter": "Work center",
    "empty": {
      "info": "No Work Lines have been added to this Work Order yet."
    }
  },
  "workOrderTimer": {
    "confirm": {
      "cancel": "Cancel",
      "confirm": "Register time",
      "discard": "Discard time",
      "info": "You have {{ minutes }} minute(s) on work order {{ workOrderNumber }} which has not been registered any operation.",
      "reportOn": "Report time on",
      "selectOperation": "Select operation"
    },
    "estimatedHours": "Est. hrs"
  },
  "workOrderObject": {
    "selectAll": "Select all",
    "objectNumber": "Object No",
    "description": "Description",
    "progressType": "Type",
    "progress": "Progress",
    "completionSystem": "Completion System",
    "select": "Select",
    "apply": "Apply",
    "checklistLink": "Digital Check List"
  },
  "workOrderObjectList": {
    "title": "Work Lines",
    "from": "From",
    "to": "To",
    "cableRouteHeader": "Cable Routes",
    "documents": "Documents",
    "currentDocuments": "Current",
    "currentObject": "Current",
    "fromObject": "From",
    "toObject": "To",
    "empty": {
      "info": "No Work Lines have been added to this Work Order yet."
    }
  },
  "pushNotification": {
    "WO_ADD_COMMENT": {
      "WORK_ORDER": {
        "body": {
          "user": "User: ",
          "madeANote": ", just made a note on your current work order: "
        }
      },
      "DEFAULT": {
        "body": {
          "user": "User: ",
          "madeANote": ", just made a note on {{ referenceType }}: ",
          "onWorkOrder": ". On your current work order: "
        }
      }
    },
    "WO_PUT_ON_HOLD": {
      "header": "Work order put on hold",
      "body": {
        "prefix": "Work order: ",
        "suffix": ", has been put on hold by: "
      }
    },
    "WO_RELEASE_PUT_ON_HOLD": {
      "body": {
        "prefix": "User: ",
        "suffix": ", just reactivated the work order: "
      }
    },
    "WO_UPDATE_OBJ_PROGRESS": {
      "header": "Object progress was updated",
      "body": {
        "prefix": "User: ",
        "suffix": ", has updated progress on the work lines. On your current work order: "
      }
    },
    "WO_UPDATE_INSTALLED_QUANTITY_ON_WORK_LINE": {
      "header": "Object installed quantity was updated",
      "body": {
        "user": "User: ",
        "updated_quantity": ", has updated installed quantity on the work line: ",
        "on_work_order": ". On your current work order: "
      }
    },
    "WO_MARK_WORK_LINE_AS_COMPLETE": {
      "body": {
        "user": "User: ",
        "just_completed": ", just completed the work line: ",
        "on_work_order": ". On your current work order: "
      }
    },
    "WO_MARK_WORK_LINE_AS_OPEN": {
      "body": {
        "user": "User: ",
        "just_completed": ", has started the work line: ",
        "on_work_order": ". On your current work order: "
      }
    },
    "WO_DOCUMENT_PROCESSED": {
      "header": "Updated Documentation",
      "body": {
        "document": "Document no: ",
        "on_work_order": ", on work order: "
      }
    },
    "DEFAULT": {
      "header": "Action was taken",
      "body": "User: {{triggeredByName}} has made a change in {{referenceName}}:{{referenceType}} in {{sourceId}} with an event: {{eventType}}"
    }
  },
  "error": {
    "page": {
      "400": {
        "title": "Invalid web address",
        "description": "Did you type this address directly? Check for typos. Did you copy and paste the address? Check that you included the entire address.",
        "button": "Return to home base"
      },
      "403": {
        "title": "Key missing...",
        "description": "Looks like you don't have the necessary permissions to view this page.",
        "button": "Get on board"
      },
      "404": {
        "title": "Looks like the page is lost at sea",
        "description": "The page you're trying to find has disappeared or no longer exists.",
        "button": "Return to home base"
      },
      "500": {
        "title": "An unexpected error occurred",
        "description": "It's not you, it's us. We have been notified of the incident. Please try again later",
        "button": "Return to home base"
      }
    },
    "dialog": {
      "internal_server_error": {
        "title": "Internal server error.",
        "description": "Try again later, or contact support.",
        "button": "OK"
      },
      "general_error": {
        "title": "Something went wrong.",
        "description": "If the problem occurs again, try refreshing the page or contact support",
        "button": "OK"
      },
      "no_connection": {
        "title": "Failed to load!",
        "description": "No connection to server.",
        "button": "Retry"
      }
    }
  },
  "versionCheck": {
    "newVersionAvailable": "New version {{version}} is available!",
    "viewReleaseNotes": "View Release Notes"
  }
}
